import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from './Navbar';
import Footer from './Footer';
import Swal from 'sweetalert2';
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

const custom_input = {
  border: "1px solid #ced4da",
  borderRadius: "4px",
  padding: "0.375rem 0.75rem",
  fontSize: "1rem",
};

const Career = () => {
  const [vacancies, setVacancies] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    number: '',
    email: '',
    apply_for: '',
    apply_position: '',
    address: '',
    desired_country: '',
    desired_visa_route: '',
    int_in_coaching: false,
    course: '',
    resume: null,
  });

  const [showCourse, setShowCourse] = useState(false);
  const [countries, setCountries] = useState([]);
  const [VisaTypes, setVisaTypes] = useState([]);

  useEffect(() => {
    axios.get("https://goforen.com/go_foren/get_country_all_data/")
      .then((res) => setCountries(res.data))
      .catch((err) => console.error("Error fetching countries:", err));

    axios.get("https://goforen.com/go_foren/get_visa_services/")
      .then((res) => setVisaTypes(res.data))
      .catch((err) => console.error("Error fetching visa services:", err));

    axios.get('https://goforen.com/go_foren/get_Opening_Vacancy_data/')
      .then(res => setVacancies(res.data))
      .catch(err => console.error("Failed to fetch vacancies", err));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSelect2 = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({ ...prev, resume: e.target.files[0] }));
  };

  const handleSwitchChange = (event) => {
    setShowCourse(event.target.checked);
    setFormData(prev => ({ ...prev, int_in_coaching: event.target.checked }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      data.append(key, value);
    });

    try {
      const res = await axios.post(
        'https://goforen.com/go_foren/apply_job_inquiry/',
        data,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );

      Swal.fire({
        icon: 'success',
        title: 'Application Submitted',
        text: res.data.success || 'Your application has been successfully submitted!',
      });

      setFormData({
        name: '',
        number: '',
        email: '',
        apply_position: '',
        address: '',
        resume: null,
      });

      document.querySelector('input[type="file"]').value = null;

    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Submission Failed',
        text: error.response?.data?.error || 'Something went wrong. Please try again.',
      });
    }
  };

  return (
    <>
      <Navbar />
      <div className="container py-5">
        <div className="xb-contact pos-rel bg-white shadow rounded p-4">
          <div className="row">
            <div className="col-12">
              <form onSubmit={handleSubmit} className="container mt-4">
                <h3 className="fw-bold border-bottom pb-2 mb-4">Apply at GoForen as a staff	</h3>

                <div className="row g-3 mb-4">
                  <div className="col-md-6">
                    <label className="form-label">Full Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[A-Za-z\s]*$/.test(value)) {
                          handleChange(e);
                        }
                      }}
                      style={custom_input}
                      className="form-control"
                      required
                      placeholder='Enter Name'
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Contact Number</label>
                    <input
                      type="text"
                      name="number"
                      value={formData.number}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[0-9]{0,10}$/.test(value)) {
                          handleChange(e);
                        }
                      }}
                      style={custom_input}
                      className="form-control"
                      maxLength="10"
                      required
                      placeholder='Enter Contact Number'
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[A-Za-z0-9._%+-]*@?[A-Za-z0-9.-]*\.?[A-Za-z]{0,4}$/.test(value)) {
                          handleChange(e);
                        }
                      }}
                      style={custom_input}
                      className="form-control"
                      required
                      placeholder='Enter Email'
                    />
                  </div>


                    <div className="col-md-6">
                      <label className="form-label">Apply Position</label>
                      <select
                        name="apply_position"
                        value={formData.apply_position}
                        onChange={handleChange}
                        className="form-select"
                        style={custom_input}
                        required
                      >
                        <option value="">Select a position...</option>
                        {vacancies.map((job) => (
                          <option key={job.id} value={job.opening_vacancy_name}>
                            {job.opening_vacancy_name}
                          </option>
                        ))}
                      </select>
                    </div>
           

           
                    <div className="col-md-6">
                      <label className="form-label">Resume</label>
                      <input
                        type="file"
                        name="resume"
                        onChange={handleFileChange}
                        style={custom_input}
                        className="form-control"
                        required
                      />
                    </div>
    

          
                  <div className="col-md-6">
                    <label className="form-label">Address</label>
                    <textarea
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      style={custom_input}
                      className="form-control"
                      required
                      placeholder='Enter Address'
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-end">
                  <button
                    type="submit"
                    style={{
                      background: "#e38508",
                      border: "1px solid #e38508",
                      color: "#fff",
                      padding: "5px 10px",
                      borderRadius: "5px",
                    }}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Career;
